
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatSDK } from '@tencentcloud/chat';

export interface ChatState {
  chat?: ChatSDK
}

const initialState: ChatState = {};

export const chat = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChat(state, { payload }: PayloadAction<{ chat: ChatSDK | undefined }>) {
      state.chat = payload.chat;
    },
  },
});

export const { setChat } = chat.actions;

export default chat.reducer;
